import React from 'react';
import { NumberInput, TextInput } from 'ui-toolkit';
import generateLabelToPayeeText from '../utilities/generateLabelToPayeeText';
import { createOnChangeHandlerGenerator } from '../utilities/createOnChangeHandlerGenerator';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import IHasMetaDataModalProps from './IHasMetaDataModalProps';
import IHasMetaDataModalState from './IHasMetaDataModalState';
import { IItemWithoutShowSellerProps } from './IItemProps';
import PurchaseItemMetaDataModal, { IPurchaseItemMetaDataModalRef } from './PurchaseItemMetaDataModal';
import SharedPurchaseItemCells from './SharedPurchaseItemCells';
import './_BuyerCredit.scss';
import './_ModalPurchasePresentationItem.scss';
import { IBuyerCreditFromSellerViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

export interface IBuyerCreditFromSellerProps
  extends IItemWithoutShowSellerProps,
    IHasItemDataProps<IBuyerCreditFromSellerViewItem>,
    IHasItemEventProps<IBuyerCreditFromSellerViewItem>,
    IHasMetaDataModalProps {
  onFocus?: () => void;
  onBlur?: (event: React.FocusEvent) => void;
}

type IBuyerCreditFromSellerState = IHasMetaDataModalState;

export default class BuyerCreditFromSeller extends React.Component<
  IBuyerCreditFromSellerProps,
  IBuyerCreditFromSellerState
> {
  public state = {
    expanded: !this.props.disableAutoExpand && this.props.data.new,
  };
  private modal = React.createRef<IPurchaseItemMetaDataModalRef>();
  private firstInput: HTMLInputElement | null = null;

  public render() {
    const { data, onChange, hasEditPermissions } = this.props;

    const generateDefaultOnChangeHandler = createOnChangeHandlerGenerator(data, onChange);
    const onSellerAtClosingChangeEvent = generateDefaultOnChangeHandler('seller_at_closing');
    const labelOnChangeEvent = generateDefaultOnChangeHandler('label');
    const payeeOnChangeEvent = generateDefaultOnChangeHandler('payee');
    return (
      <SharedPurchaseItemCells
        {...this.props}
        sellerAtClosingDisplay="text"
        className="modal-purchase-presentation-item buyer-credit"
        onBlur={this.onBlur}
        onFocus={this.onFocus}
        hasEditPermissions={hasEditPermissions}
      >
        <PurchaseItemMetaDataModal
          expanded={this.state.expanded}
          label={generateLabelToPayeeText(data.label, data.payee)}
          onToggle={this.onModalToggleEvent}
          ref={this.modal}
        >
          <div className="buyer-credit__fields">
            <TextInput
              label={'Name'}
              getInputRef={this.setFirstInput}
              onChange={labelOnChangeEvent}
              placeholder="Name"
              value={data.label}
              readOnly={!hasEditPermissions}
              debounceOnValueChange
            />
            <span className="buyer-credit__to">&nbsp;to&nbsp;</span>
            <TextInput
              label={'Payee'}
              onChange={payeeOnChangeEvent}
              placeholder="Payee"
              value={data.payee}
              readOnly={!hasEditPermissions}
              debounceOnValueChange
            />
            <NumberInput
              mode="currency"
              label="Amount"
              className="buyer-credit__amount"
              onBlur={this.onBlur}
              onFocus={this.onFocus}
              onChange={onSellerAtClosingChangeEvent}
              value={this.props.data.seller_at_closing}
              readOnly={!hasEditPermissions}
              debounceOnValueChange
            />
          </div>
        </PurchaseItemMetaDataModal>
      </SharedPurchaseItemCells>
    );
  }

  private setFirstInput = (element: HTMLInputElement) => {
    this.firstInput = element;
  };

  private onBlur = (event: React.FocusEvent) => {
    const { onBlur } = this.props;
    const node = this.modal.current;
    if (node && event.relatedTarget && !node.modalContains(event.relatedTarget as HTMLElement)) {
      this.setState({
        expanded: false,
      });
    }
    if (onBlur) {
      onBlur(event);
    }
  };

  private onFocus = () => {
    const { onFocus } = this.props;
    if (onFocus) {
      onFocus();
    }
  };

  private onModalToggleEvent = (expanded: boolean) => {
    this.setState({ expanded });
    if (this.firstInput) {
      this.firstInput.focus();
    }
  };
}
